export default {
  mobileTiles: [
    {
      company: 'Inc',
      height: '151px',
      width: '240px',
      centered: true,
      naturalHeight: 100,
      naturalWidth: 152,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/2022_Inc_BestWorkplaces_Logo.png',
      customTileStyle: 'press-logo-columns-5 wide',
    },
    {
      company: 'Fortune Bay Area 2021',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/FortuneBayArea2021.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Best Financial Services 2022',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/Fortune-2022-Financial-Services.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Best Women',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/Fortune-2022-GPTW-Women.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Most Creative People',
      height: '130px',
      width: '104px',
      naturalHeight: 130,
      naturalWidth: 104,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/FC MostCreativePeople_2021_ StandardLogo.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'MLT',
      height: '131px',
      width: '109px',
      naturalHeight: 131,
      naturalWidth: 109,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/MLT-logo-2023.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fair Pay Workplace',
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/Fair-pay-workplace.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
  topTiles: [
    {
      company: 'Inc',
      height: '192px',
      width: '240px',
      centered: true,
      naturalHeight: 122,
      naturalWidth: 152,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/2022_Inc_BestWorkplaces_Logo-desktop.png',
      customTileStyle: 'press-logo-columns-5 wide',
    },
    {
      company: 'Fortune Bay Area 2021',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/FortuneBayArea2021.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Best Financial Services 2022',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/Fortune-2022-Financial-Services.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Best Women',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/Fortune-2022-GPTW-Women.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
  bottomTiles: [
    {
      company: 'Most Creative People',
      height: '130px',
      width: '104px',
      naturalHeight: 130,
      naturalWidth: 104,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/FC MostCreativePeople_2021_ StandardLogo.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'MLT',
      height: '131px',
      width: '109px',
      naturalHeight: 131,
      naturalWidth: 109,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/MLT-logo-2023.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fair Pay Workplace',
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/Fair-pay-workplace.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
};
